//@flow
import * as React from 'react';
import { FormGroup } from 'reactstrap';
import { pontoAtendimentoService } from '../../services/pontoAtendimento.service';
import FormSelectInput from '../../components/Inputs/FormSelectInput';
import { isSudo } from '../../helpers/permissions.helper';
import { clienteService } from '../../services/cliente.service';
import { userService } from '../../services/user.service';

type Props = { onChangeText: any, entity: any, onChangeValue: any };

export default class MapaProdutosCrudListFilter extends React.PureComponent<Props> {
  render() {
    const { entity } = this.props;
    const user = userService.getCurrentUser();
    console.log(user.cliente);

    return (
      <React.Fragment>
        {isSudo() && (
          <FormGroup className="col-12 col-xl-3">
            <FormSelectInput
              name="cliente"
              id="cliente"
              label="Cliente"
              placeholder="Selecione o cliente"
              valueKey="codigoCliente"
              labelKey="label"
              required={true}
              returnFullObject={true}
              service={clienteService.findAll}
              onChange={this.props.onChangeDate}
              value={entity.cliente}
            />
          </FormGroup>
        )}

        <FormGroup className="col-12 col-xl-3">
          <FormSelectInput
            name="pontoAtendimentoId"
            id="pontoAtendimentoId"
            label="Ponto de Atendimento"
            placeholder="Selecione o PA"
            valueKey="id"
            labelKey="nome"
            required={true}
            returnFullObject={false}
            parent={isSudo() ? entity.cliente : user.cliente}
            service={
              isSudo()
                ? pontoAtendimentoService.findAll
                : pontoAtendimentoService.findAllByCliente
            }
            onChange={this.props.onChangeDate}
            value={entity.pontoAtendimentoId}
          />
        </FormGroup>
      </React.Fragment>
    );
  }
}
